<cmi-breadcrumb />
<cmi-back-button />

<div>
  @if (contentProvider(); as provider) {
    <h2
      class="text-lg w-full font-semibold mb-4 inline-flex items-center gap-2 border-b border-gray-300 pb-2">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="size-6 fill-current">
        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
        <path
          fill-rule="evenodd"
          d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
          clip-rule="evenodd" />
        <path
          d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
      </svg>
      {{ 'contentProviders.parametersTitle' | translate }}
    </h2>
  }

  @if (providerParameter(); as param) {
    <cmi-parameter-value-editor [parameterName]="param.name" [parameterType]="parameterType()" />
  }
</div>
